<template>
	<b-container
		class="height-100dvh w-100 p-0 position-relative"
		style="max-width: 100%"
	>
			<NcdTopContainer />
		<main class="tran-main-container app-bottom-padding w-100">
			<div class="max-1825">
				<div id="hideinmobile" class="cand-header d-flex mb-2">
					Transactions
				</div>
				<section class="tran-scroll">
					<div
						class="d-flex gap-3 justify-content-between tran-flex-column mob-gap-3"
					>
						<section class="d-flex flex-1 gap-3 mob-gap-3">
							<article class="tran-card-1">
								<div class="position-relative z-ind-1">
									<img
										class="tran-card-img"
										src="../../assets/newdesign/transaction/green-cash.svg"
										alt=""
									/>
									<div v-if="cardLoading" class="w-100 mt-4 mob-mt-3">
										<b-skeleton class="w-75"></b-skeleton>
									</div>
									<h4
										v-else
										class="fam-lato fw-M text-green fs-22 mob-fs-18 mt-4 mob-mt-3"
									>
										{{ interviewInfo.totalEarning.earnings }}
									</h4>
									<h5 class="fam-lato fw-LM text-green fs-16 mob-fs-14">
										Total Earnings
									</h5>
								</div>
								<img
									class="tran-back-1"
									src="../../assets/newdesign/transaction/earn-back.svg"
									alt=""
								/>
							</article>
							<article class="tran-card-2">
								<img
									class="tran-card-img"
									src="../../assets/newdesign/transaction/blue-message.svg"
									alt=""
								/>
								<div v-if="cardLoading" class="w-100 mt-4 mob-mt-3">
									<b-skeleton class="w-75"></b-skeleton>
								</div>
								<h4
									v-else
									class="fam-lato fw-M text-tertiary fs-22 mob-fs-18 mt-4 mob-mt-3"
								>
									{{ interviewInfo.interviewCount }}
								</h4>

								<h5 class="fam-lato fw-LM text-tertiary fs-16 mob-fs-14">
									Total Interviews
								</h5>
								<img
									id="hideinlaptop"
									class="tran-back-2"
									src="../../assets/newdesign/transaction/toal-back.svg"
									alt=""
								/>
							</article>
						</section>
						<div id="hideinmobile" class="tran-vert-line"></div>
						<section class="d-flex flex-1 gap-3 tran-flex-column mob-gap-3">
							<article class="tran-card-3">
								<div class="tran-yellow-tag text-white fw-B fam-lato">
									HIGHEST INTERVIEWS TAKEN FOR
								</div>
								<div class="d-flex gap-3 mt-3 position-relative z-ind-1">
									<div class="w-50">
										<h4 class="fam-lato fs-14 fw-LM text-9596AA mob-fs-11">
											Skills:
										</h4>
										<div v-if="cardLoading" class="w-100 mt-4 mob-mt-3">
											<b-skeleton class="w-75"></b-skeleton>
										</div>
										<div
											v-else
											class="d-flex flex-wrap gap-2 gap-unset text-break"
										>
											<div
												v-if="interviewInfo.skills.length == 0"
												class="fs-13 fam-lato text-italic"
											>
												No skills found
											</div>

											<template v-else>
												<article
													v-for="(skill, index) in interviewInfo.skills"
													:key="index"
													class="tran-skill-tag"
												>
													<span>{{ skill }} </span>
													<span
														class="mr-1"
														v-show="index != interviewInfo.skills.length - 1"
														>,</span
													>
												</article>
											</template>
										</div>
									</div>
									<div class="tran-vert-line-2"></div>
									<div>
										<h4 class="fam-lato fs-14 fw-LM text-9596AA mob-fs-11">
											Experience:
										</h4>
										<div v-if="cardLoading" class="w-100 mt-4 mob-mt-3">
											<b-skeleton class="w-75"></b-skeleton>
										</div>
										<div
											v-else
											class="fam-lato text-darkgrey fw-M fs-18 mob-fs-13"
										>
											<div
												v-if="interviewInfo.experience.length == 0"
												class="fs-13 fam-lato text-italic"
											>
												No experience found
											</div>

											<template v-else>
												<span
													v-for="(
														experience, index
													) in interviewInfo.experience"
													:key="index"
												>
													{{ experience }}
													<span
														v-if="index < interviewInfo.experience.length - 1"
														>,
													</span>
												</span>
												<span v-if="interviewInfo.experience.length > 0">
													{{
														interviewInfo.experience.length === 1
															? "year"
															: "years"
													}}
												</span>
											</template>
										</div>
									</div>
								</div>
								<img
									class="tran-back-3"
									src="../../assets/newdesign/transaction/highes-int-back.svg"
									alt=""
								/>
							</article>
							<article class="tran-card-4 tran-withdraw-flex">
								<img
									class="mb-2 tran-card-img"
									src="../../assets/newdesign/transaction/blue-withdraw.svg"
									alt=""
								/>
								<h4
									id="hideinmobile"
									class="fam-lato fw-M text-darkgrey fs-18 mt-4"
								>
									Withdraw
								</h4>
								<div
									class="d-flex justify-content-between align-items-center tran-widthdraw-flex-2 pointer"
									@click="goToPayment()"
								>
									<div>
										<h4
											id="hideinlaptop"
											class="fam-lato fw-M text-darkgrey mob-fs-14"
										>
											Withdraw
										</h4>
										<div v-if="cardLoading" class="w-100 mt-4 mob-mt-3">
											<b-skeleton class="w-75"></b-skeleton>
										</div>
										<h5 v-else class="fam-lato fw-R text-tertiary fs-12 mb-0">
											Go to Hire3x Wallet to withdraw your funds.
										</h5>
									</div>
									<img
										id="hideinmobile"
										src="../../assets/newdesign/transaction/blue-right-arrow.svg"
										alt=""
									/>
									<img
										id="hideinlaptop"
										src="../../assets/newdesign/home/roundRightArrow.svg"
										alt=""
									/>
								</div>
							</article>
						</section>
					</div>
					<div class="tran-main-cont">
						<template
							v-if="
								(interviews && interviews.length > 0) ||
								searchQuery ||
								filters.paymentStatus ||
								transactionLoading
							"
						>
							<div class="d-flex justify-content-between">
								<h5 class="fam-lato fw-LM fs-16 text-black">Interviews</h5>
								<div
									@click="goToTransaction()"
									id="hideinlaptop"
									class="d-flex align-items-center gap-1 fam-mont fw-M fs-14 text-blue"
								>
									View All
									<img
										src="../../assets/newdesign/transaction/blue-right-arrow.svg"
										alt=""
									/>
								</div>
							</div>
							<div
								id="hideinmobile"
								class="d-flex justify-content-between mt-3"
							>
								<div class="position-relative width-45 mr-4">
									<img
										class="tran-search-pos"
										src="../../assets/headerSearch.svg"
										alt=""
									/>
									<b-form-input
										class="resumes-search-input"
										placeholder="Search"
										type="search"
										v-model="searchQuery"
										debounce="500"
										@update="getPanelInterviews()"
										clearable
									>
									</b-form-input>
								</div>
								<div class="d-flex gap-3">
									<div class="position-relative">
										<b-button
											ref="filterBtn"
											class="candash-addBtn tran-btn"
											@click="showFilter = !showFilter"
											><img
												class="mr-2"
												src="../../assets/newdesign/transaction/filter.svg"
												alt=""
											/>Filter</b-button
										>
										<div
											v-if="filtered"
											class="filter-dot"
											style="right: 62px; top: 10px"
										></div>
										<!-- FILTER CARD  -->
										<div
											ref="filter"
											class="asp-filtercard"
											v-if="showFilter"
											v-closable="{
												exclude: ['filter', 'filterBtn', 'filterdpd'],
												handler: 'closeFilter',
											}"
										>
											<div>
												<Select
													ref="filterdpd"
													label="Status"
													:options="options"
													:selOption="filterText"
													@selected-option="filterSelected"
												/>
												<div
													class="filter-footer d-flex align-items-center justify-content-between mt-3"
												>
													<div class="padding-2-15 mob-cancelBtn">
														<b-button @click="showFilter = false"
															>Cancel</b-button
														>
													</div>
													<div class="padding-2-15 mob-cancelBtn">
														<b-button
															class="mr-3"
															:disabled="
																selectedFilter == 'Select' ||
																selectedFilter == null
															"
															@click="resetFilter"
															>Reset</b-button
														>
														<b-button
															:disabled="
																selectedFilter == 'Select' ||
																selectedFilter == null
															"
															@click="applyFilter"
															>Apply</b-button
														>
													</div>
												</div>
											</div>
										</div>
									</div>
									<!-- Export Excel Filter Card -->
									<article class="position-relative">
										<div
											style="top: 35px"
											ref="exportFilter"
											class="asp-filtercard"
											v-if="showExportFilter"
											v-closable="{
												exclude: ['exportFilter', 'exportFilterBtn'],
												handler: 'closeExport',
											}"
										>
											<div>
												<div class="export-modal-content">
													<div>
														<label class="teams-label-font fs-14 my-2 w-40"
															>From Date :</label
														>
														<DateField
															placeholder="From Date"
															:mandatory="false"
															:noLabel="true"
															format="DD-MM-YYYY"
															:id="'from-date'"
															:vmodel="fromDate"
															@select-value="updateFromDate"
															:startDate="null"
														/>
														<label class="teams-label-font fs-14 mb-2 mt-3 w-40"
															>To Date :</label
														>
														<DateField
															placeholder="To Date"
															:mandatory="false"
															:noLabel="true"
															format="DD-MM-YYYY"
															:id="'to-date'"
															:vmodel="toDate"
															@select-value="updateToDate"
															:startDate="fromDate"
														/>
													</div>
												</div>
												<div
													class="filter-footer d-flex align-items-center justify-content-between mt-3"
												>
													<div class="padding-2-15 mob-cancelBtn">
														<b-button @click="showExportFilter = false"
															>Cancel</b-button
														>
													</div>
													<div class="padding-2-15 mob-cancelBtn">
														<b-button
															class="mr-3"
															:disabled="!fromDate || !toDate"
															@click="resetExportFilter"
															>Reset</b-button
														>
														<b-button
															:disabled="!fromDate || !toDate"
															@click="applyExportFilter"
															>Export</b-button
														>
													</div>
												</div>
											</div>
										</div>

										<b-button
											@click="showExportFilter = true"
											class="candash-addBtn tran-btn"
											ref="exportFilterBtn"
											>Export Excel</b-button
										>
									</article>
								</div>
							</div>

							<div class="tran-horizontal-scroll">
								<div id="hideinmobile" class="tran-header min-width-1200">
									<span class="col-one"
										>Interview ID
										<template v-if="filterColumn == 'interviewID'">
											<img
												v-show="toggleFilter"
												class="mb-4px pointer"
												src="../../assets/newdesign/transaction/upsort.svg"
												alt=""
												@click="filterByDesc('interviewID')"
											/>
											<img
												v-show="!toggleFilter"
												class="mb-4px pointer"
												src="../../assets/newdesign/transaction/downsort.svg"
												alt=""
												@click="filterByAsc('interviewID')"
											/>
										</template>
										<img
											v-else
											class="mb-4px pointer"
											src="../../assets/newdesign/transaction/nosort.svg"
											alt=""
											@click="
												filterByAsc('interviewID'), (enableColSort = true)
											"
										/>
									</span>
									<span class="col-two"
										>Candidate Name
										<template v-if="filterColumn == 'name'">
											<img
												v-show="toggleFilter"
												class="mb-4px pointer"
												src="../../assets/newdesign/transaction/upsort.svg"
												alt=""
												@click="filterByDesc('name')"
											/>
											<img
												v-show="!toggleFilter"
												class="mb-4px pointer"
												src="../../assets/newdesign/transaction/downsort.svg"
												alt=""
												@click="filterByAsc('name')"
											/>
										</template>
										<img
											v-else
											class="mb-4px pointer"
											src="../../assets/newdesign/transaction/nosort.svg"
											alt=""
											@click="
												filterByAsc('name'), (enableColSort = true)
											" /></span
									><span class="col-three"
										>Email ID
										<template v-if="filterColumn == 'emailID'">
											<img
												v-show="toggleFilter"
												class="mb-4px pointer"
												src="../../assets/newdesign/transaction/upsort.svg"
												alt=""
												@click="filterByDesc('emailID')"
											/>
											<img
												v-show="!toggleFilter"
												class="mb-4px pointer"
												src="../../assets/newdesign/transaction/downsort.svg"
												alt=""
												@click="filterByAsc('emailID')"
											/>
										</template>
										<img
											v-else
											class="mb-4px pointer"
											src="../../assets/newdesign/transaction/nosort.svg"
											alt=""
											@click="
												filterByAsc('emailID'), (enableColSort = true)
											" /></span
									><span class="col-four">Skills</span
									><span class="col-five"
										>Role
										<template v-if="filterColumn == 'role'">
											<img
												v-show="toggleFilter"
												class="mb-4px pointer"
												src="../../assets/newdesign/transaction/upsort.svg"
												alt=""
												@click="filterByDesc('role')"
											/>
											<img
												v-show="!toggleFilter"
												class="mb-4px pointer"
												src="../../assets/newdesign/transaction/downsort.svg"
												alt=""
												@click="filterByAsc('role')"
											/>
										</template>
										<img
											v-else
											class="mb-4px pointer"
											src="../../assets/newdesign/transaction/nosort.svg"
											alt=""
											@click="
												filterByAsc('role'), (enableColSort = true)
											" /></span
									><span class="col-six">Time</span
									><span class="col-sev">Amount</span
									><span class="col-eig">Action</span>
								</div>
								<div
									class="tran-horizontal-scroll"
									v-if="
										interviews && interviews.length == 0 && !transactionLoading
									"
								>
									<div
										class="d-flex flex-column align-items-center justify-content-center no-tran-height"
									>
										<img
											src="../../assets/newdesign/transaction/no-tran.svg"
											alt=""
										/>
										<h4 class="fam-lato fw-LM fs-16 color-black mt-4">
											No results found for "{{ searchQuery || filterText }}"
										</h4>
									</div>
								</div>
								<section
									class="tran-scroll-2 min-width-1200"
									v-if="transactionLoading || interviews.length > 0"
								>
									<template
										v-if="
											interviews && interviews.length && !transactionLoading
										"
									>
										<article
											v-for="(interview, i) in interviews"
											:key="i"
											class="tran-row fam-lato fw-R fs-15 text-blue"
										>
											<div id="hideinmobile" class="tran-blue-bar"></div>
											<section class="col-one">
												<span class="tran-blue-tag">{{
													interview.interviewRequestID
												}}</span>
												<img
													class="pointer"
													@click="openJobDetails(interview, i)"
													id="hideinlaptop"
													src="../../assets/newdesign/home/roundRightArrow.svg"
													alt=""
												/>
											</section>
											<section class="col-two">{{ interview.name }}</section>

											<section class="col-three text-truncate pr-2">
												{{ interview.emailID }}
											</section>
											<section
												id="hideinmobile"
												class="col-four text-truncate pr-2"
											>
												<div class="text-truncate">
													{{ interview.skills.slice(0, 2).join(", ") }}
												</div>
												<div v-if="interview.skills.length > 2">
													+{{ interview.skills.length - 2 }} more
												</div>
											</section>
											<section id="hideinmobile" class="col-five">
												{{ interview.role }}
											</section>
											<div class="tran-wid-28 d-flex align-items-center">
												<section class="col-six">
													{{ interview.slot }}
												</section>
												<section class="col-sev">
													<div class="tran-row-tag">
														<img
															v-if="interview.paymentStatus == 0"
															src="../../assets/newdesign/transaction/red-rupee.svg"
															alt=""
														/>
														<img
															v-if="interview.paymentStatus == 1"
															src="../../assets/newdesign/transaction/yellow-money-icon.svg"
															alt=""
														/>
														<img
															v-if="interview.paymentStatus == 2"
															src="../../assets/newdesign/transaction/green-money-icon.svg"
															alt=""
														/>
														{{ interview.interviewInfo.amount }}
													</div>
												</section>
											</div>
											<div id="hideinlaptop" class="d-flex mt-2">
												<div class="width-45">
													<h5 class="fam-mont fw-LM fs-11 text-3A3C40 mb-1">
														Role Name
													</h5>
													<h5
														class="fam-mont fw-M fs-11 text-3A3C40 mb-1 w95 text-truncate"
													>
														{{ interview.role }}
													</h5>
												</div>
												<div>
													<h5 class="fam-mont fw-LM fs-11 text-3A3C40 mb-1">
														Skills:
													</h5>
													<h5
														class="fam-mont fw-M fs-11 text-3A3C40 mb-1 w-100 text-truncate"
													>
														<span>
															{{ interview.skills.slice(0, 2).join(", ") }}
														</span>
														<span v-if="interview.skills.length > 2">
															+{{ interview.skills.length - 2 }} more
														</span>
													</h5>
												</div>
											</div>
											<section id="hideinmobile" class="col-eig">
												<img
													class="pointer"
													@click="openJobDetails(interview, i)"
													src="../../assets/newdesign/transaction/view.svg"
													alt=""
												/>
											</section>
										</article>
									</template>
									<template v-if="transactionLoading">
										<article
											v-for="i in 10"
											:key="i"
											class="tran-row fam-lato fw-R fs-15 text-blue"
										>
											<div id="hideinmobile" class="tran-blue-bar"></div>
											<section v-for="i in 4" :key="i" class="col-one">
												<b-skeleton class="w-75"></b-skeleton>
											</section>

											<div class="tran-wid-28 d-flex align-items-center">
												<section class="col-six w-25">
													<b-skeleton class="w-75"></b-skeleton>
												</section>
												<section class="col-sev w-25">
													<b-skeleton class="w-75"></b-skeleton>
												</section>
											</div>
											<div id="hideinlaptop" class="d-flex mt-2">
												<div class="width-45">
													<h5 class="fam-mont fw-LM fs-11 text-3A3C40 mb-1">
														Role Name
													</h5>
													<h5
														class="fam-mont fw-M fs-11 text-3A3C40 mb-1 w95 text-truncate"
													>
														<b-skeleton class="w-75"></b-skeleton>
													</h5>
												</div>
												<div class="width-45">
													<h5 class="fam-mont fw-LM fs-11 text-3A3C40 mb-1">
														Skills:
													</h5>
													<h5
														class="fam-mont fw-M fs-11 text-3A3C40 mb-1 w-100 text-truncate"
													>
														<b-skeleton class="w-100"></b-skeleton>
													</h5>
												</div>
											</div>
											<section id="hideinmobile" class="col-eig">
												<b-skeleton class="w-75"></b-skeleton>
											</section>
										</article>
									</template>
								</section>
								<div
									id="hideinmobile"
									class="acs-paginaTion-new d-flex justify-content-between align-items-center min-width-1200"
									v-if="interviews && interviews.length > 0"
								>
									<div class="d-flex">
										<span class="acs-gotopage-text mr-2 p-1">Go to page</span>
										<div class="acs-pagination-num">
											<b-form-input
												class="no-number"
												type="number"
												v-model="goToPage"
												@keydown="validateNumber"
												@keyup.enter="
													goToPage === null || goToPage == '' ? '' : goToPages()
												"
											>
											</b-form-input>
										</div>
										<div class="acs-pagination-addbtn" @click="goToPages()">
											<b-button>
												<img
													src="../../assets/newdesign/assessPro/page-arrow.svg"
													alt=""
												/>
											</b-button>
										</div>
									</div>
									<div class="d-flex justify-content-center pagination ml-135">
										<b-pagination
											align="center"
											first-number
											last-number
											limit="4"
											v-model="page"
											@input="getPanelInterviews(), (goToPage = null)"
											:total-rows="totalPages"
											:per-page="pageCount"
										>
											<template #prev-text
												><span
													><img
														src="../../assets/newdesign/assessPro/pageLeft.svg"
														alt=""
													/> </span
											></template>
											<template #next-text
												><span
													><img
														src="../../assets/newdesign/assessPro/pageRight.svg"
														alt="" /></span
											></template>
										</b-pagination>
									</div>
									<div class="d-flex align-items-center">
										<PaginationCountSelect
											:pagecount="pageCount"
											@update-value="getPageCount"
										/>
										<div
											class="acs-gotopage-text mr-2 ml-4 d-flex align-items-center justify-content-end"
										>
											Results :
											<span class="ml-1">{{ pageStart }}</span>
											<span class="ml-1"> - {{ pageEnd }} </span>
											<span class="pl-1"></span> of <span class="pr-1"></span
											>{{ totalPages }}
										</div>
									</div>
								</div>
							</div>
						</template>
						<div
							class="d-flex flex-column align-items-center justify-content-center no-tran-height-2"
							v-if="
								interviews &&
								interviews.length == 0 &&
								!searchQuery &&
								!filters.paymentStatus
							"
						>
							<img
								src="../../assets/newdesign/transaction/no-tran.svg"
								alt=""
							/>
							<h4 class="fam-lato fw-LM fs-16 color-black mt-4">
								There are no Transactions!
							</h4>
						</div>
					</div>
				</section>
			</div>
		</main>
		<b-modal
			hide-footer
			hide-header
			centered
			id="detailModal"
			modal-class="bottom-modal"
		>
			<div>
				<div
					class="candash-reume-header d-flex align-items-center justify-content-between px-4 py-3 fam-lato fs-18 fw-LM"
				>
					Details
					<img
						class="rotate-on-hover"
						src="@/assets/newdesign/dashboard/blueCross.svg"
						alt=""
					/>
				</div>
				<div class="px-4 py-3">
					<Transaction />
				</div>
				<div class="mobjd-applied-footer justify-content-end w-100 px-4 py-3">
					<div class="mob-cancelBtn">
						<b-button>Cancel</b-button>
					</div>
					<div class="mob-addBtn position-relative">
						<b-button class="px-4">Report</b-button>
					</div>
				</div>
			</div>
		</b-modal>
		<JobDetailsModal
			v-if="showJobDetailsModal"
			:showJobDetailsModal="showJobDetailsModal"
			:interview="selectedInterview"
			:ongoing="false"
			:level="2"
			:isTransaction="true"
			@close-modal="hideJobDetails()"
			@update="getInterviewData()"
		/>
	</b-container>
</template>

<script>
import "@/assets/newdesign/transaction/transaction.css";
import Transaction from "@/components/Transaction.vue";
import NcdTopContainer from "@/components/NewCandidateDashboard/NcdTopContainer.vue";
import PaginationCountSelect from "@/components/PaginationCountSelect.vue";
import Select from "@/components/select.vue";
import transactionPage from "@/components/mixin/transactionPage";
import { Capacitor } from "@capacitor/core";
export default {
	data() {
		return {};
	},
	components: {
		PaginationCountSelect,
		NcdTopContainer,
		Transaction,
		Select,
	},
	mixins: [transactionPage],
	created() {
		this.getInterviewData();
	},
	methods: {
		goToTransaction() {
			this.$router.push("/transactionmob");
		},
		goToPayment() {
			if (Capacitor.isNativePlatform())
				window.location.replace("https://utility.hire3x.com/wallet");
			else window.open("https://utility.hire3x.com/wallet");
		},
		resetExportFilter() {
			this.fromDate = null;
			this.toDate = null;
		},
		validateNumber(event) {
			if (["e", "E", "+", "-"].includes(event.key)) {
				event.preventDefault();
			}
		},
		filterByAsc(filterBy) {
			this.order = 1;
			this.toggleFilter = !this.toggleFilter;
			this.filterColumn = filterBy;
			this.getPanelInterviews();
		},
		filterByDesc(filterBy) {
			this.order = -1;
			this.toggleFilter = !this.toggleFilter;
			this.filterColumn = filterBy;
			this.getPanelInterviews();
		},
		getPageCount(val) {
			this.pageCount = val;
			this.page = 1;
			this.getPanelInterviews();
		},
		goToPages() {
			if (this.page == this.goToPage) return;
			const maxAvailablePage = Math.ceil(this.totalPages / this.pageCount);
			const validPage = Math.min(Math.max(1, this.goToPage), maxAvailablePage);
			this.page = validPage;
			this.getPanelInterviews();
		},
		filterSelected(val) {
			this.selectedFilter = val.value;
		},
	},
};
</script>

<style></style>
